import { render, staticRenderFns } from "./ConfirmDialogLongTalkgroupCreation.vue?vue&type=template&id=de8ef52e&scoped=true"
import script from "./ConfirmDialogLongTalkgroupCreation.vue?vue&type=script&lang=js"
export * from "./ConfirmDialogLongTalkgroupCreation.vue?vue&type=script&lang=js"
import style0 from "./ConfirmDialogLongTalkgroupCreation.vue?vue&type=style&index=0&id=de8ef52e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de8ef52e",
  null
  
)

export default component.exports